import {isNil} from 'ramda';

import {UpdatedByResponseBody} from '@dms/api/core';
import {EMPTY_PLACEHOLDER} from '@dms/shared';

export const formatUpdatedByName = (user: UpdatedByResponseBody | null) => {
  if (isNil(user)) {
    return EMPTY_PLACEHOLDER;
  }

  return user.fullName;
};
